// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  width: 100%;
}

/* Christmas animations */
@keyframes snow {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(360deg);
    opacity: 0;
  }
}

.snowflake {
  position: fixed;
  top: -10px;
  color: white;
  font-size: 1em;
  animation: snow 10s linear infinite;
  pointer-events: none;
  z-index: 1000;
}

/* Button styles */
.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.btn-primary {
  background: linear-gradient(135deg, var(--christmas-red), #d32f2f);
  color: white;
  box-shadow: 0 4px 15px rgba(196, 30, 58, 0.4);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(196, 30, 58, 0.6);
}

.btn-secondary {
  background: linear-gradient(135deg, var(--christmas-green), #2e7d32);
  color: white;
  box-shadow: 0 4px 15px rgba(34, 139, 34, 0.4);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(34, 139, 34, 0.6);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Card styles */
.card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 24px;
  margin: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Input styles */
.input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 16px;
  margin: 8px 0;
}

.input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.input:focus {
  outline: none;
  border-color: var(--christmas-gold);
  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);
}

/* Mobile-first responsive */
@media (max-width: 768px) {
  .card {
    margin: 8px;
    padding: 16px;
  }
  
  .btn {
    width: 100%;
    margin: 8px 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,oBAAoB;EACpB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oEAAoE;EACpE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".App {\n  min-height: 100vh;\n  width: 100%;\n}\n\n/* Christmas animations */\n@keyframes snow {\n  0% {\n    transform: translateY(0) rotate(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100vh) rotate(360deg);\n    opacity: 0;\n  }\n}\n\n.snowflake {\n  position: fixed;\n  top: -10px;\n  color: white;\n  font-size: 1em;\n  animation: snow 10s linear infinite;\n  pointer-events: none;\n  z-index: 1000;\n}\n\n/* Button styles */\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--christmas-red), #d32f2f);\n  color: white;\n  box-shadow: 0 4px 15px rgba(196, 30, 58, 0.4);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(196, 30, 58, 0.6);\n}\n\n.btn-secondary {\n  background: linear-gradient(135deg, var(--christmas-green), #2e7d32);\n  color: white;\n  box-shadow: 0 4px 15px rgba(34, 139, 34, 0.4);\n}\n\n.btn-secondary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(34, 139, 34, 0.6);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Card styles */\n.card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 24px;\n  margin: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Input styles */\n.input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  font-size: 16px;\n  margin: 8px 0;\n}\n\n.input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.input:focus {\n  outline: none;\n  border-color: var(--christmas-gold);\n  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);\n}\n\n/* Mobile-first responsive */\n@media (max-width: 768px) {\n  .card {\n    margin: 8px;\n    padding: 16px;\n  }\n  \n  .btn {\n    width: 100%;\n    margin: 8px 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
